import { SurveyHistorical } from '../../../../shared/types/survey.interface';

export interface SurveyHistoricalModalProps {
    historical: SurveyHistorical[];
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    title: 'Título',
    code: 'Código',
    withTemplate: 'Tema de Comware',
    description: 'Descripción',
    logo: 'Logo',
    projects: 'Proyecto',
};
